



export const URL = {
    reacptcha_key:'6LcxTeMUAAAAALV_MUV_m_mUzfEjYW4776JYgPHK',
    homepage_package:'https://t-mobilitat.atm.cat/opendatafront',
    urlDescarga:'https://t-mobilitat.atm.cat/opendata/static/download/',
    urlDescargaWBL:'https://t-mobilitat.atm.cat/opendata/static/download/WBL/',
    urlFichaTecnica:'https://t-mobilitat.atm.cat/opendata/static/ficha/tecnica/',
    urlFichaTecnicaWBL:'https://t-mobilitat.atm.cat/opendata/static/ficha/tecnica/WBL/es',
    urlSubmitForm:'https://t-mobilitat.atm.cat/opendata/static/register/request/',
    urlStatic:'https://t-mobilitat.atm.cat/web/t-mobilitat/dades-obertes/cataleg-dades/informacio-estatica',
    urlStaticCru:'https://t-mobilitat.atm.cat/web/t-mobilitat/dades-obertes/cataleg-dades/informacio-estatica-cru',
    urlRt:'https://t-mobilitat.atm.cat/web/t-mobilitat/dades-obertes/cataleg-dades/informacio-temps-real',
    urlAlertJSON:'https://t-mobilitat.atm.cat/opendata/alerts/json/user/token/open',
    urlAlertPB:'https://t-mobilitat.atm.cat/opendata/alerts/user/token/open',
    urlTripUpJSON:'https://t-mobilitat.atm.cat/opendata/trip_updates/json/user/token/open',
    urlTripUpPB:'https://t-mobilitat.atm.cat/opendata/trip_updates/user/token/open'
}
const version = 'v0.0.3'
//PRO